import config from "../config";
import { css } from "emotion";
import { getCountry, getLocality } from "../utils/Location";
import { lastOfType } from "../utils/CssUtils";

const Breadcrumbs = ({ event, color }) => {
  const overBar = css({
    margin: "0 auto",
    maxWidth: "1200px",
    padding: "12px 60px",
    span: {
      margin: "0 8px"
    },
    ol: {
      listStyle: "none"
    },
    li: {
      margin: 0,
      display: "inline-block",
      a: {
        color: `${color} !important`,
        textDecoration: "underline",
        textTransform: "capitalize",
        fontSize: 14,
        fontWeight: 400
      },
      [lastOfType()]: {
        a: {
          textDecoration: "none"
        }
      }
    },

    "@media(max-width: 500px)": {
      padding: "8px 14px"
    }
  });
  const country = getCountry(event.data);
  const locality = getLocality(event.data);
  const locale = (event.data && event.data.location) ? event.data.location.toLowerCase() : false;
  const marketingUrl = config("WEBSITE_URL");

  if (!country || !locality || !locale || !marketingUrl) {
    return null;
  }

  return (
    <div style={{ borderBottom: "1px solid white" }}>
      <ol
        className={overBar}
        itemscope
        itemtype="https://schema.org/BreadcrumbList"
      >
        <li
          itemprop="itemListElement"
          itemscope
          itemtype="https://schema.org/ListItem"
        >
          <a
            itemprop="item"
            href={`${marketingUrl}/${locale}/search`}
            aria-label="All Events"
          >
            <span itemprop="name">All Events</span>
          </a>
          <meta itemprop="position" content="1" />
          <span aria-hidden={true}>></span>
        </li>
        <li
          itemprop="itemListElement"
          itemscope
          itemtype="https://schema.org/ListItem"
        >
          <a
            itemprop="item"
            href={`${marketingUrl}/${locale}/events/${country}/${locality
              .split(" ")
              .join("-")}`}
            aria-label={`${locality.charAt(0).toUpperCase() +
              locality.slice(1)} Events`}
          >
            <span itemprop="name">
              {locality.charAt(0).toUpperCase() + locality.slice(1)} Events
            </span>
          </a>
          <meta itemprop="position" content="2" />
          <span aria-hidden={true}>></span>
        </li>
        <li
          itemprop="itemListElement"
          itemscope
          itemtype="https://schema.org/ListItem"
        >
          <a
            itemprop="item"
            href={`/${event.data.slug}`}
            aria-label={event.data.name}
          >
            <span itemprop="name">{event.data.name}</span>
          </a>
          <meta itemprop="position" content="3" />
        </li>
      </ol>
    </div>
  );
};

export default Breadcrumbs;
